import * as Yup from "yup";

export const MacroroutineSchema = Yup.object().shape({
  categoryType: Yup.string().required("Ce champ est requis"),
  title: Yup.string().required("Ce champ est requis"),
  triggerTitle: Yup.string().required("Ce champ est requis"),
  miniroutines: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Ce champ est requis"),
    })
  ),
});

